import type { JSX } from 'react'

import { api } from '@setplex/tria-api'
import { useUnit } from 'effector-react'
import { useEffect } from 'react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import * as pinLockFeature from '~/features/pin-lock'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import * as model from './model'

export function Title(): JSX.Element {
  return <AppTitle t='series' />
}

const skin = era.skin('routes/shows/details')

ShowDetailsPage.displayName = 'ShowDetailsPage'
export function ShowDetailsPage(): JSX.Element {
  const current = useUnit(api.tvshows.$currentTvShow)
  const episodes = useUnit(model.$episodes)

  const setCategoryId = useUnit(model.setCategoryId)
  const setShowIndex = useUnit(model.setShowIndex)

  const isLocked = useUnit(pinLockFeature.$isLockedFn)
  const locked = isLocked({ id: current?.id, locked: current?.locked })

  useEffect(() => {
    const searchParams: URLSearchParams = new URLSearchParams(
      window.location.search
    )
    const categoryId: string | null = searchParams.get('categoryId')
    const showIndex: string | null = searchParams.get('showIndex')
    if (categoryId && !isNaN(Number(categoryId))) {
      setCategoryId(Number(categoryId))
    }
    if (showIndex && !isNaN(Number(showIndex))) {
      setShowIndex(Number(showIndex))
    }

    // `window.location.search` is declared as a dependency because
    // we need to react on location change
    // TODO: window.location.search is not reactive, so we need to find another way to do it
    // oxlint-disable-next-line react/exhaustive-deps
  }, [setCategoryId, setShowIndex, window.location.search])

  const hasEpisodes = Boolean(current?.episodeCount) && episodes.length > 0
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper className='content-details-page'>
        <ui.RenderSkin name='current' />
        <ui.RenderSkin name='currentTrailer' />
        <ui.RenderSkin name='posterContent' />
        {!locked && current && current.isWithSeason && (
          <>
            <ui.RenderSkin name='season' />
            <ui.RenderSkin name='season/episodes' />
          </>
        )}
        {!locked && current && !current.isWithSeason && hasEpisodes && (
          <>
            <ui.RenderSkin name='raw/episodes' />
          </>
        )}
        <ui.RenderSkin name='recommended' />
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
